
<ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid, validate }" tag="div">
  <b-form @submit.stop.prevent="handleSubmit(onSubmit)" @input="validate({ silent: true })">
    <div class="container p-0">
      <div
        v-if="!$isMobile()"
        id="glisser-deposer-overlay"
        class="document-container d-flex flex-column justify-content-center align-items-center text-center invisible"
      >
        <div class="cadre-drag-drop bg-white d-flex flex-column justify-content-center">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <div>
              <svg-icon
                class="svg-icon-big rotate-25 py-0 mr-2"
                icon-name="icone-photo"
              ></svg-icon>
              <svg-icon class="svg-icon-big py-0 ml-2" icon-name="ic-file"></svg-icon>
            </div>

            <div class="mt-2" v-html="content.libDragDropExecution" />
          </div>
        </div>
        <span class="petitTexte pt-1 securise-drag-drop">
          <svg-icon icon-name="ic-security" class="mt-n0-5"> </svg-icon>
          {{ content.libSecurise }}
        </span>
      </div>

      <div
        v-show="filesCount === 2 && erreurNombreFichier.montrerMessage"
        id="bloc-nombre-fichier"
        class="pr-1 row"
      >
        <div class="d-inline-flex col">
          <div class="cercleErreur cercleErreur-televersement mr-1">
            <span class="cercleErreur-contenu">!</span>
          </div>
          <div class="d-flex">
            <ul class="pl-0 m-0 d-inline-block">
              <li id="message-nombre-fichier" class="televersementInvalide"></li>
            </ul>
          </div>
        </div>
      </div>

      <form enctype="multipart/form-data" novalidate>
        <FilesSender :is="componentFilesSender">
          <template #slotTeleversement>
            <!-- Premier -->
            <ValidationProvider rules="required">
              <b-form-group v-model="doc1Selectionne">
                <div class="selection-document-parent my-2">
                  <div v-if="!$isMobile()" v-html="content.libTitreDoc1"></div>
                  <TeleversementErrors id="erreur-televersement-premier"> </TeleversementErrors>

                  <div
                    id="cadre-selection-document-premier"
                    class="cadre-selection-document bordure-cadre-opaque d-flex flex-column justify-content-center my-1 mx-0 px-2 py-1 pt-sm-2"
                  >
                    <div
                      v-if="$isMobile()"
                      :class="doc1Selectionne ? 'd-flex float-left' : 'mb-n1'"
                      v-html="content.libTitreDoc1"
                    />
                    <div :class="doc1Selectionne ? 'd-flex float-left' : 'flex-row'">
                      <div
                        id="televersement__file-area-premier"
                        :class="{
                          'd-none': !doc1Selectionne,
                        }"
                      >
                        <div
                          class="cadre-photo w-100 h-100 flex-row justify-content-end float-left"
                        >
                          <div
                            id="televersement__preview-area-premier"
                            data-is="container-files-premier"
                          >
                            <button
                              id="button-remove-premier"
                              type="button"
                              class="btnVide positionBtnFermer p-0 mr-2 mt-2 mb-n5 float-right"
                              data-action="remove-file-premier"
                            >
                              <svg-icon
                                class="btnVide positionBtnFermer svg-icon typeTitre py-0"
                                icon-name="icone-fermer-v2"
                                stroke="currentColor"
                                fill="$couleur-fond-primaire"
                              >
                              </svg-icon>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        id="televersement__selection-area-premier"
                        :class="{
                          'd-none': doc1Selectionne,
                        }"
                      >
                        <div v-if="!$isMobile()" class="mx-auto">
                          <svg-icon
                            class="typeTresGrandTitre p-0 m-1 cursor_pointer"
                            icon-name="ic-upload-file"
                            stroke="currentColor"
                            fill="$couleur-fond-primaire"
                          ></svg-icon>
                          <div class="m-0 mb-1" v-html="content.libDragDrop" />
                        </div>

                        <label>
                          <input
                            id="file-input-premier"
                            type="file"
                            class="d-none input-file"
                            accept=".jpg,.pdf,.png,.jpe,.pjepg"
                            @change="ajoutFichier('premier')"
                          />
                        </label>
                        <b-button
                          variant="primaire"
                          class="btn shadow w-100 w-md-auto mb-1 mx-xs-auto py-1 px-0 px-md-5"
                          onclick="document.getElementById('file-input-premier').click()"
                        >
                          <span v-html="content.libBoutonSelectionnerDocument" />
                        </b-button>
                      </div>
                      <div
                        v-if="$isMobile()"
                        class="info-document d-flex petitTexte justify-content-center"
                        :class="doc1Selectionne ? 'd-flex mt-auto ml-auto' : 'mb-n1'"
                      >
                        <span class="pl-2">
                          <svg-icon icon-name="ic-security" class="mt-n0-5"> </svg-icon>
                          {{ content.libSecurise }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="!$isMobile()"
                    class="info-document d-flex petitTexte justify-content-between"
                  >
                    <p class="my-0" v-html="content.libFormat" />
                    <span class="pl-2">
                      <svg-icon icon-name="ic-security" class="mt-n0-5"> </svg-icon>
                      {{ content.libSecurise }}
                    </span>
                  </div>
                </div>
              </b-form-group>
            </ValidationProvider>
            <!-- Deuxieme -->
            <ValidationProvider rules="required">
              <b-form-group v-model="doc2Selectionne">
                <!-- Deuxieme -->
                <div class="selection-document-parent my-2">
                  <div v-if="!$isMobile()" v-html="content.libTitreDoc2" />
                  <TeleversementErrors id="erreur-televersement-deuxieme"> </TeleversementErrors>

                  <div
                    id="cadre-selection-document-deuxieme"
                    class="cadre-selection-document bordure-cadre-opaque d-flex flex-column justify-content-center my-1 mx-0 px-2 py-1 pt-sm-2"
                  >
                    <div
                      v-if="$isMobile()"
                      :class="doc2Selectionne ? 'd-flex float-left' : 'mb-n1'"
                      v-html="content.libTitreDoc2"
                    />
                    <div :class="doc2Selectionne ? 'd-flex float-left' : 'flex-row'">
                      <div
                        id="televersement__file-area-deuxieme"
                        :class="{
                          'd-none': !doc2Selectionne,
                        }"
                      >
                        <div
                          class="cadre-photo w-100 h-100 flex-row justify-content-end float-left pb-1"
                        >
                          <div
                            id="televersement__preview-area-deuxieme"
                            data-is="container-files-deuxieme"
                          >
                            <button
                              id="button-remove-deuxieme"
                              type="button"
                              class="btnVide positionBtnFermer p-0 mr-2 mt-2 mb-n5 float-right"
                              data-action="remove-file-deuxieme"
                            >
                              <svg-icon
                                class="btnVide positionBtnFermer svg-icon typeTitre py-0"
                                icon-name="icone-fermer-v2"
                                stroke="currentColor"
                                fill="$couleur-fond-primaire"
                              >
                              </svg-icon>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        id="televersement__selection-area-deuxieme"
                        :class="{
                          'd-none': doc2Selectionne,
                        }"
                      >
                        <div v-if="!$isMobile()" class="mx-auto">
                          <svg-icon
                            class="typeTresGrandTitre p-0 m-1 cursor_pointer"
                            icon-name="ic-upload-file"
                            stroke="currentColor"
                            fill="$couleur-fond-primaire"
                          ></svg-icon>
                          <div class="texte m-0 mb-1" v-html="content.libDragDrop" />
                        </div>

                        <label>
                          <input
                            id="file-input-deuxieme"
                            type="file"
                            class="d-none input-file float-left"
                            accept=".jpg,.pdf,.png,.jpe,.pjepg"
                            @change="ajoutFichier('deuxieme')"
                          />
                        </label>
                        <b-button
                          variant="primaire"
                          class="btn shadow w-100 w-md-auto mb-1 mx-xs-auto py-1 px-0 px-md-5"
                          onclick="document.getElementById('file-input-deuxieme').click()"
                        >
                          <span v-html="content.libBoutonSelectionnerDocument" />
                        </b-button>
                      </div>
                      <div
                        v-if="$isMobile()"
                        class="info-document d-flex petitTexte justify-content-center"
                        :class="doc2Selectionne ? 'mt-auto ml-auto' : 'm-0'"
                      >
                        <span class="pl-2">
                          <svg-icon icon-name="ic-security" class="mt-n0-5"> </svg-icon>
                          {{ content.libSecurise }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="!$isMobile()"
                    class="info-document d-flex petitTexte justify-content-between"
                  >
                    <p class="my-0" v-html="content.libFormat" />
                    <span class="pl-2">
                      <svg-icon icon-name="ic-security" class="mt-n0-5"> </svg-icon>
                      {{ content.libSecurise }}
                    </span>
                  </div>
                </div>
              </b-form-group>
            </ValidationProvider>
          </template>
        </FilesSender>
      </form>
      <TeleversementWarnings id="warning-televersement"> </TeleversementWarnings>
    </div>
    <div class="d-flex flex-column align-items-xs-center align-items-sm-start mx-4 mx-md-0">
      <b-button
        type="submit"
        variant="primaire"
        class="w-auto px-2 py-1 px-xs-5 mx-0 mb-2"
        :disabled="invalid || isSubmitted"
        :class="{ valid: !invalid }"
      >
        <div class="d-inline-flex w-auto">
          <div v-if="isSubmitted" class="mr-1">
            <b-spinner small :label="$t('chargement')"></b-spinner>
          </div>
          {{ content.libBoutonContinuer }}
        </div>
      </b-button>
    </div>
  </b-form>
</ValidationObserver>
